/**
 * 实名认证mixin逻辑
 * */
import BindIdCard from '@/views/BindIdCard'
import { mapState } from 'vuex'
import { Dialog } from 'vant'

const VERIFY_LEVEL_0 = 0
const VERIFY_LEVEL_1 = 1
const VERIFY_LEVEL_2 = 2
const VERIFY_LEVEL_3 = 3
const VERIFY_LEVEL_4 = 4
const UserVerifiedEventKey = 'user_id_verified'
const UserVerifiedCancelKey = 'user_id_verify_cancel'

export default {
    components: {
        BindIdCard,
    },
    data() {
        return {
            showBindIDCard: false,
            bindIDCardClosable: false,
            bindIDCardLoginOutable: false,
        }
    },
    computed: {
        ...mapState({
            verifyInfo: state => state.verifyInfo
        })
    },
    methods: {
        offListenVerifyEvent() {
            this.$off([UserVerifiedEventKey, UserVerifiedCancelKey])
        },
        updateVerifyInfo(res) {
            return new Promise((resolve, reject) => {
                // 校验游戏是否强制实名，并且用户是否已经实名
                // 当用户未实名时弹出实名认证弹窗
                // const {
                //     id_card = '',
                //     is_verified = false,
                //     anti = 0,
                //     api_time = 0,
                // } = res.data
                //
                // const verifyInfo = {
                //     id_card,
                //     is_verified,
                //     anti,
                //     api_time,
                // }
                // this.$store.dispatch('updateVerifyInfo', verifyInfo).
                //     then(() => {
                //
                //     })
                const { is_verified, anti } = this.verifyInfo

                if (is_verified) {
                    return resolve(res)
                }
                this.bindIDCardClosable = true
                this.bindIDCardLoginOutable = false
                this.$on(UserVerifiedEventKey, () => {
                    return resolve(res)
                })

                return resolve(res) // 关闭实名认证

                // switch (Number(anti)) {
                //     case VERIFY_LEVEL_0: {
                //         return resolve(res)
                //     }
                //     case VERIFY_LEVEL_1: {
                //         // handleCancel()
                //         this.$on(UserVerifiedCancelKey, () => {
                //             return resolve(res)
                //         })
                //         break
                //     }
                //     case VERIFY_LEVEL_2: {
                //         this.bindIDCardClosable = false
                //         this.bindIDCardLoginOutable = true
                //         this.$off([UserVerifiedCancelKey])
                //         this.$on(UserVerifiedCancelKey, () => {
                //             return reject(res)
                //         })
                //         // handleSuccess()
                //         break
                //     }
                //     case VERIFY_LEVEL_3 : {
                //         // handleCancel()
                //         this.$on(UserVerifiedCancelKey, () => {
                //             return resolve(res)
                //         })
                //         break
                //     }
                //     case VERIFY_LEVEL_4 : {
                //         // handleCancel()
                //         this.bindIDCardClosable = false
                //         this.bindIDCardLoginOutable = true
                //         this.$off([UserVerifiedCancelKey])
                //         this.$on(UserVerifiedCancelKey, () => {
                //             return reject(res)
                //         })
                //         break
                //     }
                //     default: {
                //         break
                //     }
                // }
                // this.openBindIDModal()
            })
        },
        openBindIDModal() {
            this.showBindIDCard = true
        },
        onBindIDClose() {
            // 2022.01.13 实名可跳过
            console.log('close')
            this.showBindIDCard = false
            this.$emit(UserVerifiedCancelKey)
        },
        onBindIDSuccess() {
            this.showBindIDCard = false
            this.$emit(UserVerifiedEventKey)
        },
        closeBindIDModal() {
            navigator.vibrate = navigator?.vibrate ||
                navigator?.webkitVibrate ||
                navigator?.mozVibrate ||
                navigator?.msVibrate
            console.log('navigator.vibrate >>>', navigator?.vibrate || '浏览器不支持震动')

            // 2022.01.13 强制实名关闭弹框时，使手机震动
            if(navigator?.vibrate) {
                navigator.vibrate([500, 300, 400, 300])
            }

            // 2022.01.13 强制实名
            Dialog.confirm({
                message: '根据国家规定，完成充值或继续游戏需要先实名；为保证您的游戏体验，请尽快完成实名认证。',
                confirmButtonText: '返回认证',
                confirmButtonColor: '#cc9733',
                cancelButtonText: '残忍退出',
                cancelButtonColor: '#999999',
            })
            .then(() => {
                // on confirm
            })
            .catch(() => {
                // on cancel
                console.log("closeBindIDModal")
                this.showBindIDCard = false

                // 2022.01.18 直接跳转登录页面，而不是 reLogin
                // window.postMessage({ key: 'reLogin', value: true }, '*')
                this.$router.push({
                    path: '/login',
                    query: { ...(this.$route?.query ? { ...this.$route.query } : {}) }
                })
            })
        },
    },

    mounted() {
        this.offListenVerifyEvent()
        // this.$on('user_id_verified')
    },
    beforeDestroy() {
        // this.offListenVerifyEvent()
    },
}
